import { render, staticRenderFns } from "./ModalSelecionaCompetencia.vue?vue&type=template&id=7ca9fd04"
import script from "./ModalSelecionaCompetencia.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports